<h4 [style.margin]="'6px 16px 12px'">{{ 'Upcoming tasks' | translate }}</h4>

<mat-divider></mat-divider>

<mat-list>
  <mat-list-item *ngFor="let run of futureRuns">
    {{ run }}
  </mat-list-item>
</mat-list>
